import { render, staticRenderFns } from "./texteditor.vue?vue&type=template&id=894e0972&"
import script from "./texteditor.vue?vue&type=script&lang=js&"
export * from "./texteditor.vue?vue&type=script&lang=js&"
import style0 from "./texteditor.vue?vue&type=style&index=0&id=894e0972&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports